import { createStore } from 'vuex'
import mutations from './mutations'
import actions from './actions'

export default createStore({
  state: {
    asyncQueue: [],
    user: null,
    editor: false,
    pages: {},
    currentPage: {
      title: '',
      description: '',
      image: ''
    }
  },
  mutations,
  actions
})
